export class WorkNumber {
  tasknumber: string; 
  description: string;
  closedate: Date;
  company_id: number;
  costplaceA: string;
  costplaceB: string;
  tableNumber: number;
}
